// RemoveDesignProModal.js
import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setBuildingPermitModals } from "../../store/actions/permitFormActions/modalControlStateActions";
import { handleDesignProRemove } from "../permitPackageFunctions/savedProjectsFunctions";
import { formikRef } from "../../store/formikStore/formikStore";
import {
  TEMPLATE_CATEGORY_IDS,
  getTemplateCategoryConfig,
} from "../permitForms/utils/templateCategoryHelpers";

const DESIGN_PRO_SELECTOR_NAMES = [
  "engineerDesignProfessional",
  "architectDesignProfessional",
  "designProfessional",
];

const RemoveDesignProModal = () => {
  const formik = formikRef.current;

  const { addingNewDesignPro, activeTemplateCategory } = useSelector(
    (state) => state.buildingState,
  );
  const { addDesignProConfirmOpen } = useSelector(
    (state) => state.modalControlState.buildingPermit,
  );

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setBuildingPermitModals({ addDesignProConfirmOpen: false }));
  };

  const handleConfirm = () => {
    const categoryConfig = getTemplateCategoryConfig(
      activeTemplateCategory?.categoryId,
    );
    const selectorName =
      categoryConfig?.selectorName ||
      DESIGN_PRO_SELECTOR_NAMES.find((name) => formik?.values?.[name]);
    const selectedId = selectorName ? formik?.values?.[selectorName] : "";

    handleDesignProRemove(formik?.values, formik?.setValues, dispatch, {
      categoryId:
        activeTemplateCategory?.categoryId ||
        (selectorName === "engineerDesignProfessional"
          ? TEMPLATE_CATEGORY_IDS.ENGINEER
          : selectorName === "architectDesignProfessional"
            ? TEMPLATE_CATEGORY_IDS.ARCHITECT
            : TEMPLATE_CATEGORY_IDS.DESIGN_PROFESSIONAL),
      selectorName,
      selectedId,
    });
  };

  return (
    <Modal
      open={addDesignProConfirmOpen}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: "transparent",
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          //   border: "2px solid #000",
          boxShadow: 2,
          p: 4,
        }}
      >
        <Typography id="modal-title" variant="h6" component="h2">
          {addingNewDesignPro
            ? "Cancel the addition of a new design professional"
            : "Confirm the removal of the new design professional"}
        </Typography>
        <Typography id="modal-description" sx={{ mt: 2 }}>
          {addingNewDesignPro
            ? "Would you like to cancel the addition of a new Design Professional?"
            : "Would you like to remove this design professional from your list?"}
        </Typography>
        <Box
          sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 2 }}
        >
          <Button color="error" onClick={handleConfirm} sx={{ ml: 2 }}>
            Confirm
          </Button>
          <Button variant="contained" onClick={handleClose} color="primary">
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default React.memo(RemoveDesignProModal);
